var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 28.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.64,0A1.14,1.14,0,0,0,60.5,1.17v10.2L51.9.46a1.14,1.14,0,0,0-2,.71V14.62a1.15,1.15,0,1,0,2.29,0V4.33l8.59,11a1.16,1.16,0,0,0,.89.43A1,1,0,0,0,62,15.7a1.14,1.14,0,0,0,.77-1.08V1.17A1.15,1.15,0,0,0,61.64,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.34,13a1,1,0,0,0-.81-.38,1.21,1.21,0,0,0-.65.18,5.58,5.58,0,0,1-3,.79A5.34,5.34,0,0,1,2.36,7.89c0-3.36,2.17-5.71,5.29-5.71a6,6,0,0,1,2.9.65h0a1.35,1.35,0,0,0,.61.16A1,1,0,0,0,12,2.5,1,1,0,0,0,12.2,2a1.09,1.09,0,0,0-.55-.91,8,8,0,0,0-4-1C3.14,0,0,3.26,0,7.89s3.12,7.86,7.75,7.86A7.56,7.56,0,0,0,12,14.48a1.17,1.17,0,0,0,.5-.91.85.85,0,0,0-.2-.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.21,15.77a9.23,9.23,0,0,0,5.19-1.68A1.51,1.51,0,0,0,80,12.9V8.27a1.13,1.13,0,0,0-1.13-1.13H73.93a1.09,1.09,0,0,0,0,2.17h3.9v3.11a6,6,0,0,1-3.58,1.17c-3.29,0-5.42-2.23-5.42-5.69S71,2.2,74.19,2.2A6.13,6.13,0,0,1,77,2.87a1.35,1.35,0,0,0,.67.18,1,1,0,0,0,.9-.5A1.06,1.06,0,0,0,78.73,2a1.09,1.09,0,0,0-.56-.91A8.1,8.1,0,0,0,74,0c-4.36,0-7.53,3.31-7.53,7.87,0,4.78,3,7.87,7.76,7.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.86,13.43H86V9.07h5.56a1.11,1.11,0,1,0,0-2.21H86V2.41h6.91a1.15,1.15,0,0,0,0-2.29h-8a1.16,1.16,0,0,0-1.15,1.15V14.58a1.15,1.15,0,0,0,1.15,1.14h8a1.15,1.15,0,0,0,0-2.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,14.6V1.16a1.16,1.16,0,0,0-2.32,0V6.87H18.29V1.16a1.16,1.16,0,0,0-2.32,0V14.6a1.16,1.16,0,0,0,2.32,0V9.08H25.7V14.6a1.16,1.16,0,0,0,2.32,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.92.58A1.07,1.07,0,0,0,39,0h0A1.06,1.06,0,0,0,38,.57L31,14.17a1.07,1.07,0,0,0,0,1,1.06,1.06,0,0,0,.91.51h5.14a1.07,1.07,0,0,0,0-2.13H33.66L39,3.37l5.28,10.22H40.86a1.07,1.07,0,0,0,0,2.13H46a1.06,1.06,0,0,0,.91-.51,1.07,1.07,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.52,21.47a.72.72,0,0,0-.72.72v2.15H13.89V22.19a.73.73,0,0,0-1.45,0V28a.73.73,0,0,0,1.45,0V25.7H16.8V28a.72.72,0,0,0,1.44,0V22.19a.72.72,0,0,0-.72-.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.44,27.28H22.23V25.73H24a.69.69,0,0,0,0-1.37H22.23V22.89h2.11A.68.68,0,0,0,25,22.2a.67.67,0,0,0-.67-.68H21.45a.67.67,0,0,0-.67.67V28a.67.67,0,0,0,.67.67h3a.69.69,0,0,0,0-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,22a.82.82,0,0,0-1.56,0l-2.45,5.76a.7.7,0,0,0-.06.27.67.67,0,0,0,.68.67.64.64,0,0,0,.63-.41L28.74,27h2.79l.54,1.32a.71.71,0,0,0,.7.45.68.68,0,0,0,.68-.67.74.74,0,0,0-.06-.28Zm0,3.57H29.3l.84-2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.29,27.28H36.91V22.19a.73.73,0,0,0-1.45,0v5.74a.72.72,0,0,0,.72.72h3.11a.69.69,0,1,0,0-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.81,21.52H41.23a.69.69,0,0,0,0,1.37H42.8V28a.72.72,0,0,0,.73.72.71.71,0,0,0,.71-.72V22.89h1.57a.69.69,0,0,0,0-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.64,21.47a.72.72,0,0,0-.72.72v2.15H50V22.19a.73.73,0,0,0-1.45,0V28A.73.73,0,0,0,50,28V25.7h2.91V28a.72.72,0,1,0,1.44,0V22.19a.72.72,0,0,0-.72-.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.29,27.13a2.36,2.36,0,0,1-1,.26A2.17,2.17,0,0,1,58,25.08a2.11,2.11,0,0,1,2.13-2.3,2.48,2.48,0,0,1,1,.22.9.9,0,0,0,.37.07.64.64,0,0,0,.59-.34.75.75,0,0,0,.09-.33.69.69,0,0,0-.44-.62,3.53,3.53,0,0,0-1.61-.37,3.46,3.46,0,0,0-3.64,3.67,3.48,3.48,0,0,0,3.67,3.68,3.32,3.32,0,0,0,1.94-.49.74.74,0,0,0,.33-.59.58.58,0,0,0-.13-.38c-.21-.29-.5-.37-1-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.82,22a.81.81,0,0,0-.76-.56.83.83,0,0,0-.79.56l-2.45,5.76a.7.7,0,0,0-.06.27.67.67,0,0,0,.68.67.64.64,0,0,0,.63-.41L65.62,27H68.4L69,28.28a.68.68,0,0,0,.7.45.67.67,0,0,0,.67-.67.72.72,0,0,0,0-.28Zm0,3.57H66.18L67,23.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.67,25.77a2.13,2.13,0,0,0,1.25-2c0-1-.45-2.24-2.61-2.24l-1.5,0a.72.72,0,0,0-.72.72V28a.73.73,0,0,0,1.45,0V26.07h.67l1.66,2.26a.79.79,0,0,0,.66.4.68.68,0,0,0,.7-.67.73.73,0,0,0-.15-.44Zm-2.13-2.89h.71c.78,0,1.16.29,1.16.88s-.65.95-1.2.95h-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.93,27.28h-2.2V25.73h1.81a.69.69,0,0,0,0-1.37H80.73V22.89h2.1a.67.67,0,0,0,.67-.69.67.67,0,0,0-.67-.68H80a.67.67,0,0,0-.67.67V28a.67.67,0,0,0,.67.67h3a.69.69,0,0,0,0-1.37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChcLogo);
export default __webpack_public_path__ + "static/media/chc-logo.7f096060537b9d5b6ae8dca1166ae254.svg";
export { ForwardRef as ReactComponent };